import { Button } from "@studyplus/boron-ui";
import { Form, Formik, FormikHelpers } from "formik";
import { Modal } from "../../../../../components/atoms/Modal";
import { StudentInactivationReason } from "../UploadForm/useImportStudentPasscodeInactivation";
import { DisabledFeaturesNotice } from "./DisabledFeaturesNotice";
import {
  InactivationReasonSelector,
  Values,
} from "./InactivationReasonSelector";
import { StudentCountConfirmation } from "./StudentCountConfirmation";
import { validationSchema } from "./validationSchema";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (
    reason: StudentInactivationReason,
    setFieldError: FormikHelpers<Values>["setFieldError"],
  ) => void;
  studentCount: number;
  studentCountByGrade: { grade: string; count: number }[];
};

export const StudentPasscodeInactivationConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  studentCount,
  studentCountByGrade,
}: Props) => {
  const initialValues: Values = { reason: "" };

  const handleSubmit = (values: Values, actions: FormikHelpers<Values>) => {
    if (values.reason !== "") {
      onConfirm(values.reason, actions.setFieldError);
    }
    actions.setSubmitting(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="max-w-[74rem] w-[90%] mx-auto my-8 rounded-lg overflow-hidden"
    >
      <Modal.Header onClose={onClose}>対象生徒の確認</Modal.Header>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({
          setFieldValue,
          setFieldTouched,
          errors,
          touched,
          isSubmitting,
          isValid,
        }) => (
          <Form>
            <Modal.Body>
              <StudentCountConfirmation
                studentCount={studentCount}
                studentCountByGrade={studentCountByGrade}
              />
              <DisabledFeaturesNotice />
              <InactivationReasonSelector
                errors={errors}
                touched={touched}
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
              />
              <div className="flex justify-center gap-4 mt-8">
                <Button
                  variant="outline"
                  onClick={onClose}
                  className="min-w-[8rem] md:min-w-[12rem]"
                >
                  キャンセル
                </Button>
                <Button
                  type="submit"
                  disabled={!isValid || isSubmitting}
                  className="min-w-[8rem] md:min-w-[12rem]"
                >
                  連携を停止
                </Button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
